import * as rnFormat from './format.service';
import * as rnLocaleFormat from './locale-format.filter';
import * as rnLocaleOrderBy from './locale-order-by.filter';
import * as rnAbbr from './abbr.filter';

export default angular.module('rhino.components.locale.format', [])
  .factory(rnFormat.name, rnFormat.default)
  .filter(rnLocaleFormat.name, rnLocaleFormat.default)
  .filter(rnLocaleOrderBy.name, rnLocaleOrderBy.default)
  .filter(rnAbbr.name, rnAbbr.default)
  .name;
